import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <div className="w-full space-y-6">
      <div className="space-y-2">
        <h1 className="font-bold font-heading text-foreground text-xl tracking-tight">
          ເຂົ້າລະບົບ
        </h1>
        <p className="font-sans text-muted-foreground text-sm">
          ໃສ່ອີເມວ ແລະ ລະຫັດຜ່ານເພື່ອເຂົ້າໃຊ້ລະບົບຂາຍຫນ້າຮ້ານ
        </p>
      </div>
      <SignInForm />
    </div>
  );
}
